import { cn } from '~/lib/cn';

interface TechGridProps {
  className?: string;
}

/**
 * Engineering grid background — 1px frost-white lines at 5% opacity, 40px grid.
 * Pure CSS via background-image gradients, no SVG overhead.
 * Decorative: aria-hidden, pointer-events-none.
 */
function TechGrid({ className }: TechGridProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('pointer-events-none select-none', className)}
      style={{
        backgroundImage: [
          'linear-gradient(to right, rgba(232, 236, 244, 0.05) 1px, transparent 1px)',
          'linear-gradient(to bottom, rgba(232, 236, 244, 0.05) 1px, transparent 1px)',
        ].join(', '),
        backgroundSize: '40px 40px',
      }}
    />
  );
}

export { TechGrid };
export type { TechGridProps };
export default TechGrid;
